import React, { createContext, useContext, useState, ReactNode } from 'react';
import { UserDataLink } from '../services/UserEvaluation/types';

interface UserContextType {
  userData: UserDataLink | null;
  setUserData: (data: UserDataLink) => void;
  loading: boolean;
  setLoading: (value: boolean) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserEvaluationProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [userData, setUserData] = useState<UserDataLink | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <UserContext.Provider
      value={{ userData, setUserData, loading, setLoading }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserEvaluationContext = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
